import styled, { css } from "styled-components";

const ForAnotherDayStyled = styled.div` 
    display: flex;
    flex-direction: column;
    gap: 32px;

 .titleWrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start ;
    gap: 24px;
 }

 .headerTitle {
    font-size: 2.6rem;
    font-weight: 700;
    color: #1B1E1C;
    font-family: ${props => props.theme.fontBold};
 }

 .addressWrapper {
    display: flex;
    flex-direction: column;
    padding: 16px;
    align-items: flex-start;
    border-radius: 5px;
    border: 1px solid #CFD0CF;
 
 }

 .semiTitle {
    font-size: 1.4rem;
    font-weight: 700;
    color: #1B1E1C;
 }

 .addressInfo {
    text-align: left;
    width: 70%;
    font-size: 1.2rem;
    font-weight: 400;
    color: #1B1E1C;
 }

 form {
    display: flex;
    flex-direction: column;
    gap: 40px;

  


 }

 form .radio-option {
    display: flex;
    align-items: center;
    border: 1px solid #CFD0CF;
    padding: 12px 20px;
    height: 48px;
    margin-bottom: 10px;
    border-radius: 5px;

    & > label {
        margin: 0;
        font-size: 1.4rem;
        font-weight: 700;
        color: #1B1E1C;
    }

   
}

.active {
        border: 1px solid #008755 !important;
    }

form .radio-option-checked {
    background-color: #00A76A;
}

p {
    font-size: 1.4rem;
    font-weight: 400;
    color: #1B1E1C;

}

form .radio-option input[type="radio"] {
    display: none;

    
}
form .radio-option:checked {
    background-color: #00A76A; }

form .radio-option label {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    padding-left: 28px;
}

form .radio-option label::before {
    content: '';
    display: inline-block;
    width: 24px;
    height: 24px;
    border: 1px solid #757575;
    border-radius: 50%;
    margin-right: 10px;
    background-color: white;
   
}

form .radio-option input[type="radio"]:checked + label::before {
    background-color: #00A76A;
    border-color: #00A76A;
    content: url(${props => props.radioContent});
    font-size: 1.6rem;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
}

form .radio-option input[type="radio"]:checked + label::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid #008755;
    border-radius: 5px;
    pointer-events: none;
}

input[type=radio]+label:after, input[type=radio]+label:before {
    bottom: calc(100% - 15px);
}

.active {
        border: 1px solid #008755 !important;
    }

    


.infoBoard { 
    width: 100%;
    height: 104px;
    border-radius: 5px;
    background: #DEEBF5;
    border: 2px solid #217BBE;
    padding: 16px 24px;
    display: flex;
    text-align: start;


    & p {
        margin: 0;
        font-size: 14;
        font-weight: 400;
        line-height: 24px;
    }

    & > strong {
        font-size: 1.4rem;
    }
}

.termsWrapper {
    display: flex;
    gap: 8px;
    flex-direction: column;
    align-items: start;
}

.terms {
    font-size: 1.4rem;
    font-weight: 700;
    color: #008755;
    cursor: pointer;
    text-decoration: underline;
}

.confirmationLabel {
    text-align: start;
    font-size: 1.4rem;
    font-weight: 400;
    color: #1B1E1C;
}

.submitPanel {
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: start !important;
}

`;




export { ForAnotherDayStyled };